import React, { Fragment, useState } from "react";
import { Card, CardBody, CardHeader, Col, Dropdown, DropdownItem, DropdownMenu, DropdownToggle, Row } from "reactstrap";
import { H3, H5, LI, P, UL } from "../../../AbstractElements";
import CountUp from 'react-countup';
import { Collection, Due, Invoice, RevenueMeter, Total } from "../../../Constant";
import { useSelector } from "react-redux";

const TotalCollMeter = ({ collection, years, selectedYear, setSelectedYear }) => {
    const authState = useSelector((state) => state.auth)
    const collectionMeter = collection;

    const [dropdownOpen, setDropdownOpen] = useState(false);

    const toggleDropdown = () => setDropdownOpen(!dropdownOpen);
    return (
        <Fragment>
            <Col  md="6" lg="4">
                <Row>
                    <Col xl="12" md="12" className="box-col-12">
                        <Card className="order-widget" style={{height:'217px'}}>
                            <CardHeader className="pb-0 d-flex justify-content-between align-items-center">
                                <H3> {RevenueMeter} </H3>
                                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                                    <DropdownToggle caret color="primary" className="btn-sm px-3 py-1" style={{ fontSize: "12px", padding: "2px 6px" }}>
                                        {selectedYear}
                                    </DropdownToggle>
                                    <DropdownMenu>
                                        {years.map((year) => (
                                            <DropdownItem key={year} onClick={() => { setSelectedYear(year) }}>
                                                {year}
                                            </DropdownItem>
                                        ))}
                                    </DropdownMenu>
                                </Dropdown>
                            </CardHeader>
                            <CardBody>
                                <Row className="heder-widget">
                                    <Col className="col-5">
                                        <span>{Total}</span>
                                        <H3 attrH3={{ className: "total-num counter" }}>
                                            <CountUp end={collectionMeter.percentage} duration={0.8} decimals={2} className="mb-0 counter" style={{ color: 'var(--default-primary)' }} />%
                                        </H3>
                                    </Col>
                                    <Col className="col-7">
                                        <div className="text-end">
                                            <UL attrUL={{ className: "simple-list" }}>
                                                <LI>{Invoice}
                                                    <span className="product-stts font-primary m-l-10">{authState.currency} {collectionMeter.total_amount}
                                                    </span>
                                                </LI>
                                                <LI>{Due}
                                                    <span className="product-stts font-primary m-l-10">{authState.currency} {collectionMeter.dues}
                                                    </span>
                                                </LI>
                                                <LI>{Collection}
                                                    <span className="product-stts font-primary m-l-10">{authState.currency} {collectionMeter.collection}
                                                    </span>
                                                </LI>
                                            </UL>
                                        </div>
                                    </Col>
                                </Row>
                                <div className="new-order mt-4">
                                    <div>
                                        <div className="progress sm-progress-bar">
                                            <div className="progress-bar bg-secondary" role="progressbar" style={{ width: `${collectionMeter.percentage}%` }} aria-valuenow={collectionMeter.percentage} aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Col>
        </Fragment>
    );
};

export default TotalCollMeter;